import { defineComponent, h } from 'vue';
import { QBtn, QDialog, QIcon, QBanner } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';
import ControlPicker from './controlPicker.jsx';

export default defineComponent({
    name: 'notification-dsgn',
    mixins: [BaseComponent],
    components: {
        QBtn,
        QDialog,
        QIcon,
        QBanner,
        ControlPicker
    },
    data: function () {
        return {
            pickervisible: false,
            picker: null,
        }
    },
    props: {
        type: null,
        schemakey: null,
    },
    methods: {
        addContent(e) {
            e.cancelBubble = true;
            e.preventDefault();
            e.stopPropagation();

            this.picker = <ControlPicker confirm={this.confirmAddControl} cancel={this.cancelAddControl}></ControlPicker>;
            this.pickervisible = true;
        },
        async confirmAddControl(id, title) {
            this.pickervisible = false;

            try {
                const schema_ = await utils.schema.get(id);
                const schema = utils.schema.resolve_Of(schema_)
                const model = utils.schema.createDefaultModel(schema, this.Root);
                this.controlData.Controls.push(model);
            }
            catch (e) {
                alert(e);
            }
        },
        cancelAddControl() {
            this.pickervisible = false;
        },
        pickerInput(value) {
            this.pickervisible = value;
        },
        generateItemsFromArray(items) {
            let returnItems = [];

            if (items && Array.isArray(items)) {
                items.forEach((c, index) => {
                    if (!(typeof c === 'object'))
                        return;

                    let DynamicControl = utils.getDesignerComponent(c);

                    if (!c.$objectId) c.$objectId = utils.generateUUID();

                    let id = c.$objectId;
                    if (index) id += '_' + index;

                    returnItems.push(
                        <DynamicControl
                            key={id}
                            type={c.ControlType}
                            name={c.ControlData.Name}
                            root={this.root}
                            controlData={c.ControlData}
                            designmodel={c}
                        >
                        </DynamicControl>
                    );
                });
            }

            if (this.selected$)
                returnItems.push(
                    <div class="property-grid">
                        {utils.tt(`Add control`,
                            <QBtn flat size="sm" icon="mdi-plus-circle" color="blue-8" style={{ zIndex: 2 }} onClick={(e) => this.addContent(e)} />, 'right')}
                    </div>
                );

            return returnItems;
        }
    },
    render() {
        let type = this.controlData.Color;
        let textColor = this.controlData.Color;
        let icon = 'mdi mdi-information';

        if (type == 'info') {
            textColor = 'primary';
            icon = 'mdi mdi-information';
        }
        else if (type == 'warning') {
            textColor = 'warning'; // 'outbound';
            icon = 'mdi mdi-alert'
        }
        else if (type == 'error') {
            textColor = 'error';
            icon = 'mdi mdi-alert'
        }
        else if (type == 'success') {
            textColor = 'success';
            icon = 'mdi mdi-information'
        }

        let title;
        let body;
        let notificationControls = (
            <div class="d-flex ml-4">
                {this.generateItemsFromArray(this.controlData.Controls)}
            </div>
        );

        if (this.controlData.Title && this.controlData.Body) {
            title = <div style={{ padding: 0, color: `var(--q-${textColor})` }}>{this.controlData.Title}</div>;
            body = <div style={{ padding: 0, color: `var(--q-${textColor})` }}>{this.controlData.Body}</div>;
        }
        else if (this.controlData.Title)
            title = <div style={{ padding: 0, color: `var(--q-${textColor})` }}>{this.controlData.Title}</div>;
        else if (this.controlData.Body)
            body = <div style={{ padding: 0, color: `var(--q-${textColor})` }}>{this.controlData.Body}</div>;

        const bannerContent = [
            title,
            body,
            this.subBody ? <div class="text-caption" style={{ padding: 0, color: `var(--q-${textColor})` }}>{this.subBody}</div> : null,
            notificationControls
        ];

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={{ ...utils.getSize(this.controlData ? this.controlData.SizeOptions : null, this.parentType, this.$parent) }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QBanner rounded dense dismissible={this.controlData.Dismissible} class={"q-mb-md bg-" + textColor + "-2"} vSlots={{
                    avatar: () => <QIcon name={icon.replace(/^mdi\s+/, '')} color={textColor} class="q-mr-md" />,
                    default: () => bannerContent
                }} />

                <QDialog modelValue={this.pickervisible} onUpdate:modelValue={(value) => this.pickerInput(value)} style={{ maxWidth: '860px' }}>
                    <div style={{ maxHeight: '80vh', overflow: 'auto' }}>{this.picker}</div>
                </QDialog>
            </div>
        );
    }
});
